import { useEffect, useState } from "react";

function diffParts(ms) {
  const s = Math.max(0, Math.floor(ms / 1000));
  return {
    days: Math.floor(s / 86400),
    hours: Math.floor((s % 86400) / 3600),
    minutes: Math.floor((s % 3600) / 60),
    seconds: s % 60,
  };
}

const pad = (n) => String(n).padStart(2, "0");

export const TripCountdown = ({ startDate, endDate, label, variant }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!startDate) return null;
  const start = new Date(startDate.includes("T") ? startDate : startDate + "T00:00:00").getTime();
  const end = endDate ? new Date(endDate + "T23:59:59").getTime() : null;
  const plain = variant === "plain";

  // Phase 3 — trip complete
  if (end && now > end) {
    return (
      <div data-testid="trip-countdown" data-phase="complete" className="text-center py-1">
        <div className="font-heading font-extrabold text-2xl text-white">Trip complete 🎉</div>
        <div className="text-xs text-white/70 mt-0.5">Thank you for journeying with us</div>
      </div>
    );
  }

  // Phase 2 — trip underway (count up)
  if (now >= start) {
    const dayNum = Math.floor((now - start) / 86400000) + 1;
    const totalDays = end ? Math.floor((end - start) / 86400000) + 1 : null;
    return (
      <div data-testid="trip-countdown" data-phase="underway" className="text-center py-1">
        <div className="text-[11px] uppercase tracking-widest text-white/60 font-semibold">The journey is underway</div>
        <div className="font-heading font-extrabold text-3xl text-white leading-tight" data-testid="trip-countdown-day">
          Day {dayNum}
        </div>
        {totalDays && <div className="text-xs text-white/70">of {totalDays} days</div>}
      </div>
    );
  }

  // Phase 1 — countdown to departure
  const p = diffParts(start - now);
  const units = [
    { v: p.days, l: "days" },
    { v: pad(p.hours), l: "hrs" },
    { v: pad(p.minutes), l: "min" },
  ];
  if (plain) {
    const pu = [{ v: p.days, l: "Days" }, { v: pad(p.hours), l: "Hours" }, { v: pad(p.minutes), l: "Minutes" }];
    return (
      <div data-testid="trip-countdown" data-phase="countdown">
        <div className="text-center text-[13px] uppercase tracking-[0.18em] font-bold mb-3" style={{ color: "#E0A73A" }}>{label || "We begin the journey"}</div>
        <div className="flex items-stretch">
          {pu.map((u, i) => (
            <div key={u.l} className="flex-1 text-center relative">
              {i > 0 && <span className="absolute left-0 top-1 bottom-1 w-px bg-white/20" />}
              <div className="font-heading font-extrabold text-4xl text-white leading-none tabular-nums">{u.v}</div>
              <div className="text-[11px] uppercase tracking-[0.15em] text-white/70 mt-2">{u.l}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }
  return (
    <div data-testid="trip-countdown" data-phase="countdown" className="text-center py-1">
      <div className="text-[11px] uppercase tracking-widest text-white/60 font-semibold mb-2">Departing in</div>
      <div className="flex items-stretch justify-center gap-2">
        {units.map((u) => (
          <div key={u.l} className="min-w-[52px] rounded-xl bg-white/10 px-2 py-1.5 backdrop-blur-sm">
            <div className="font-heading font-extrabold text-2xl text-white tabular-nums leading-none">{u.v}</div>
            <div className="text-[10px] uppercase tracking-wide text-white/60 mt-1">{u.l}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TripCountdown;
